import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'GenerationLauncher' })({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: 24,
        flexWrap: 'wrap'
    },
    text: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        flex: 1000,
        minWidth: 320
    },
    title: {
        margin: 0,
        padding: 0,
        color: '#232323',
        fontSize: 20,
        fontWeight: 700,
        lineHeight: '150%'
    },
    limits: {
        color: '#F5726A',
        '&:after': {
            content: '" "'
        }
    },
    description: {
        margin: 0,
        padding: 0,
        color: '#232323',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '150%'
    },
    action: {
        color: '#fff',
        borderRadius: 12,
        padding: '16px 32px',
        textTransform: 'none',
        background: 'linear-gradient(249deg, #FF8B61 7.18%, #D92E7F 172.88%)',
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '16px',
        whiteSpace: 'nowrap',
        flex: '1 1 auto'
    }
});
